import React, { useMemo } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import { selectors, stateKeys } from '../../model';
import { useStoreSelector } from '../../hooks/useStoreSelector';
import { useHandlers } from '../../contexts';
import { isFn } from '../../utils';
import styles from './Option.module.scss';

const createIsSelectedSelector = (value) => (state) => {
  const {
    [stateKeys.currentValue]: currentValue,
    [stateKeys.multiple]: multiple,
  } = state;

  return multiple
    ? currentValue?.includes(value) ?? false
    : currentValue === value;
};

const renderSelector = (state) =>
  selectors.selectValue(state, stateKeys.renderOption);

export const Option = ({ option }) => {
  const { value, disabled, content, children } = option;

  const isSelectedSelector = useMemo(
    () => createIsSelectedSelector(value),
    [value]
  );

  const isSelected = useStoreSelector(isSelectedSelector);
  const renderOption = useStoreSelector(renderSelector);

  const { onOptionClick } = useHandlers();

  return (
    <div
      className={cn(styles.root, { [styles.disabled]: disabled })}
      onClick={disabled ? undefined : () => onOptionClick(option)}
    >
      <div className={styles.content}>
        {isFn(renderOption) ? renderOption(option) : content || children}
      </div>
      <div className={cn(styles.icon, { [styles.selected]: isSelected })}>
        <Icon type="check" />
      </div>
    </div>
  );
};

export default Option;
